import { useSyncExternalStore } from "react";
import {
  getLocationSnapshot,
  pushLocation,
  replaceLocation,
  subscribeLocation,
} from "./location-store";

/**
 * Reads the SPA's current location and exposes the navigation verbs. A thin
 * `useSyncExternalStore` view over the single module-level location store, so
 * every caller (AuthGate, App, pages) shares one location and one popstate
 * listener rather than each holding its own copy.
 */
export function usePortalPath(): {
  pathname: string;
  search: string;
  navigate(path: string): void;
  replace(path: string): void;
} {
  const location = useSyncExternalStore(
    subscribeLocation,
    getLocationSnapshot,
    getLocationSnapshot,
  );
  return {
    pathname: location.pathname,
    search: location.search,
    navigate: pushLocation,
    replace: replaceLocation,
  };
}
